const logoPopup = document.getElementById('logo-popup');
const logoPopupCloseButton = document.getElementById('logo-popup__close-button');
const logoPopupInner = document.getElementById('logo-popup__inner');
const logoPopupTrigger = document.getElementById('logo-popup-trigger');

if (logoPopup) {
  logoPopup.addEventListener('close', function () {
    document.body.classList.remove('prevent-scroll');
  });
}

if (logoPopupTrigger) {
  logoPopupTrigger.addEventListener('click', function () {
    logoPopup.showModal();

    document.body.classList.add('prevent-scroll');
  });

  document.addEventListener('click', function (event) {
    if (logoPopup.open && !logoPopupInner.contains(event.target) && !event.target.closest('#logo-popup-trigger') && !event.target.closest('#upload-button')) {
      logoPopup.close();
    }
  });
}

if (logoPopupCloseButton) {
  logoPopupCloseButton.addEventListener('click', function () {
    logoPopup.close();
  });
}
